// Task Management Permissions

export const TASKS_INDEX = 81;
export const TASKS_SHOW = TASKS_INDEX;
export const TASKS_CREATE = 82;
export const TASKS_EDIT = 83;
export const TASKS_DELETE = 84;
export const TASKS_CHANGE_STATUS = 112;
export const TASKS_TERMINATE = 113;
export const TASKS_SEND_REPLY = 128;
export const TASKS_RESTORE = 1383;
